import { render } from "./TilesCollection.vue?vue&type=template&id=3bd244da&scoped=true"
import script from "./TilesCollection.vue?vue&type=script&lang=js"
export * from "./TilesCollection.vue?vue&type=script&lang=js"

import "./TilesCollection.vue?vue&type=style&index=0&id=3bd244da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd244da"]])

export default __exports__